import { Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import PageWrapper from '/components/page-wrapper'
import NotifyPassesMenu from './notify-passes-menu'

const NotifyPassSubpageLayout = ({ title, HelpText, heading, template, pass, onClose, children }) => (
  <PageWrapper
    title={title}
    HelpText={HelpText}
    heading={heading}
    selectedTemplate={template}
    menu={<NotifyPassesMenu template={template} selectedPass={pass} selectedPasses={pass ? [pass] : []} />}
  >
    <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box sx={{ flex: '0 0 48px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: 2 }}>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {children}
      </Box>
    </Box>
  </PageWrapper>
)

export default NotifyPassSubpageLayout
